import { setRangeMin } from './helpers';

export const setMinPrice = setRangeMin('price');
